export enum CarePlusAuthenticationState {
  ANONYMOUS = 'ANONYMOUS',
  GUEST = 'GUEST',
  CAREPLUS_GUEST = 'CAREPLUS_GUEST',
  PARTIALLY_AUTHENTICATED = 'PARTIALLY_AUTHENTICATED',
  AUTHENTICATED = 'AUTHENTICATED',
  IMPERSONATION_UNLICENSED = 'IMPERSONATION_UNLICENSED',
  IMPERSONATION_LICENSED = 'IMPERSONATION_LICENSED',
}
